import { Component, OnInit, HostListener } from '@angular/core';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-apphomelayout',
  templateUrl: './apphomelayout.component.html',
  styleUrls: ['./apphomelayout.component.scss'],
})
export class ApphomelayoutComponent implements OnInit {
  backgroundColor = '';
  constructor(
    public messageService: MessageService,
    public generalDataRepo: GeneralDataRepository
  ) {}

  ngOnInit(): void {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    let header = document.getElementsByTagName('app-headermenu')[0];
    let main = document.getElementsByTagName('html')[0];

    if (main.scrollTop > 15) {
      header.classList.add('active');
    } else {
      header.classList.remove('active');
    }
  }
}
